import { useTranslation } from "react-i18next";
import "./TestPage.scss";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import { MdClose, MdSave } from 'react-icons/md';
import { IoArrowForwardSharp, IoClose, IoDocumentTextSharp } from 'react-icons/io5';
import { IoIosRefresh } from "react-icons/io";
import { FullPageMap, MARKER_COLORS } from "../../components/fullPageMap/FullPageMap";
import { CustomLoadingButton } from "../../components/ui/CustomButton";
import GooglePlacesSelect from "../../components/googlePlacesSelect/GooglePlacesSelect";
import AddressAutocomplete from "../../components/googlePlacesSelect/AddressAutocomplete";
import GoogleMapsWrapper from "../../components/fullPageMap/GoogleMapsWrapper";

const TestPage = () => {
    const { t } = useTranslation();
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const parts = location.pathname.split("/");
    const [passedDocId, setPassedDocId] = useState(parts[parts.length - 1]);
    const [batchData, setBatchData] = useState(null);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const googleApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const [selectedLocation, setSelectedLocation] = useState(null);


    const handleAddressSelect = (location) => {
        setSelectedLocation(location);
        if (location) {
            console.log('Selected Address:', location.address);
            console.log('Latitude:', location.lat);
            console.log('Longitude:', location.lng);
        }
    };

    return (
        <motion.div
            className="test-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <div className="test-page-main-wrapper">
                    <div className="navbar">
                        <div className="navbar-left">
                            <h1 className="main-title">Title</h1>
                        </div>
                        <div className="navbar-right">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="left"
                                endIcon={<IoIosRefresh />}
                                onClick={async () => { }}
                            >
                                {t('refresh')}
                            </CustomLoadingButton>
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="right"
                                endIcon={<MdClose />}
                                onClick={() => navigate(-1)}>
                                {t('close')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                    <div className="content-summary-wrapper">
                        <div className="content-wrapper">
                            <GoogleMapsWrapper />
                        </div>
                        <div className="summary-wrapper">
                            <div className="summary-content">
                                <GooglePlacesSelect />
                                <div style={{ maxWidth: '500px', margin: '2rem auto' }}>
                                    <h2>Address Search</h2>
                                    <AddressAutocomplete
                                        onSelect={handleAddressSelect}
                                        apiKey={googleApiKey}
                                        placeholder="address..."
                                    />
                                    {selectedLocation && (
                                        <div style={{ marginTop: '1rem' }}>
                                            <h3>Selected Location:</h3>
                                            <p>Address: {selectedLocation.address}</p>
                                            <p>Latitude: {selectedLocation.lat}</p>
                                            <p>Longitude: {selectedLocation.lng}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </motion.div >
    )
};

export default TestPage